<template>
  <div class="page-wrap">
    <el-row>
      <el-col :span="4">
        <slideTab :tabList="tabList" @selectKey="getSelectKey"></slideTab>
      </el-col>
      <el-col :span="17" v-if="activeIndex === 'intro'">
          <div class="markdown-content" v-html="md1"></div>
      </el-col>
      <el-col :span="17" v-if="activeIndex === 'mode'">
          <div class="markdown-content" v-html="md2"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import slideTab from "../components/slideTab.vue";
import md1 from "../assets/markdown/yuying.md";
import md2 from "../assets/markdown/jiekou.md";
export default {
  name: "Cooperation",
  components: {
    slideTab
  },
  data() {
    return {
      activeIndex: 'intro',
      md1,
      md2,
      tabList: [
        {
          text: "运营相关",
          name: "intro",
          children: []
        },
        {
          text: "接口相关",
          name: "mode",
          children: []
        }
      ]
    };
  },
  methods: {
    getSelectKey(key) {
        this.activeIndex = key
      console.log(key);
    }
  }
};
</script>
<style lang="scss">
.markdown-content {
  line-height: 1.8;
  padding: 20px;

  p {
    margin-bottom: 15px;
  }

  a {
    color: #409EFF;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
<style lang="scss" scoped>
.cooperation {
  min-height: 100vh;
  padding: 80px;
}
.qa-btn {
  padding-top: 30px;
  a {
    display: block;
    border: 1px solid rgb(7, 7, 132);
    padding: 10px 0;
    width: 120px;
    text-align: center;
    border-radius: 4px;
    color: rgb(7, 7, 132);
  }
}
</style>
